import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaGithub, FaSnapchat, } from "react-icons/fa";
import { getSocialDetails, updateSocial } from "../../../UseContext/ApiHelpers";
import { profileContext } from "../../../UseContext/ProfileContext";
import { BASE_URL_STATIC } from "../../../../../config";
import { ApiContext } from "../../../UseContext/ApiCall";

const OtherSoc = ({ open, close, socialMediaId, OtherSoc }) => {

  const [input, setInput] = useState({
    plateform: "",
    sociallink: "",
    userhandle: "",
  });

  const socialsocialMedia = [
    {
      name: "instagram",
      icon: <FaInstagram />,
    },
    {
      name: "facebook",
      icon: <FaFacebook />,
    },
    {
      name: "twitter",
      icon: <FaTwitter />,
    },
    {
      name: "linkedin",
      icon: <FaLinkedin />,
    },
    {
      name: "github",
      icon: <FaGithub />,
    },
    {
      name: "snapchat",
      icon: <FaSnapchat />,
    },
  ];

  useEffect(() => {
    setInput({
      plateform: OtherSoc.plateform,
      sociallink: OtherSoc.sociallink,
      userhandle: OtherSoc.userhandle,
    });
  }
    , [OtherSoc]
  )


  const { setSocial } = useContext(profileContext);
  const { loggedInUserId } = useContext(ApiContext);

  const socialDetails = { socialMediaId, ...input };

  async function hanldeSubmit(e) {
    e.preventDefault();

    await updateSocial(socialDetails)
      .then(() =>
        getSocialDetails(loggedInUserId)
          .then((res) => setSocial(res))
      );

    close()
  }

  function handleChange(e) {
    setInput({ ...input, [e.target.name]: e.target.value });
  }

  return (
    <>
      <section>
        <Modal
          show={open}
          onHide={close}
          centered
          backdrop="static"
          keyboard={false}
          className="create-call"
        >
          <Modal.Header closeButton>&nbsp;</Modal.Header>
          <Modal.Body>
            <form action="" onSubmit={hanldeSubmit}>
              <h5 >Other Social Media</h5>

              <div className="">
                <span
                  className="d-flex align-content-center"
                  style={{
                    marginRight: "5px",
                    background: "#f5f5f5",
                    padding: "6px 10px",
                    borderRadius: "10px",
                    width: "120px",
                  }}
                >
                  <img src={`${BASE_URL_STATIC}/icon/platform.svg`} alt="" />
                  <p
                    style={{
                      fontSize: "15px",
                      margin: "auto",
                      color: "#616161",
                    }}
                  >
                    Platform
                  </p>
                </span>

                <div className="col-lg-11">
                  <select
                    className="form-control"
                    required
                    value={input.plateform}
                    onChange={handleChange}
                    name="plateform"
                    style={{
                      fontWeight: "600",
                      border: "0px",
                      borderBottom: "2px solid #a6a6a659",
                      marginTop: "12px",
                    }}
                  >
                    {OtherSoc.plateform && (
                      <option style={{ textAlign: "center", color: "#616161" }} value={OtherSoc.plateform}>{OtherSoc.plateform}</option>
                    )}
                    {socialsocialMedia.filter(e => e.name !== OtherSoc.plateform).map((e, i) => (
                      <option style={{ textAlign: "center", color: "#616161" }} key={i} value={e.name}>
                        {e.name}
                      </option>
                    ))}
                  </select>
                </div>

                <span
                  className="d-flex align-content-center"
                  style={{
                    margin: "10px 0px",
                    background: "#f5f5f5",
                    padding: "6px 10px",
                    borderRadius: "10px",
                    width: "100px",
                  }}
                >
                  <img src={`${BASE_URL_STATIC}/icon/degree.svg`} alt="" />

                  <p
                    style={{
                      fontSize: "15px",
                      margin: "auto",
                      color: "#616161",
                    }}
                  >
                    user id
                  </p>
                </span>

                <input
                  type="text"
                  onChange={handleChange}
                  name="userhandle"
                  required
                  defaultValue={OtherSoc.userhandle}
                  style={{
                    border: "none",
                    borderBottom: "2px solid #d4d4d4",
                    width: "85%",
                    margin: "auto",
                    marginLeft: "10px",
                    padding: "5px 10px",
                  }}
                />

                <span
                  className="d-flex align-content-center"
                  style={{
                    margin: "10px 0px",
                    background: "#f5f5f5",
                    padding: "6px 10px",
                    borderRadius: "10px",
                    width: "100px",
                  }}
                >
                  <img src={`${BASE_URL_STATIC}/icon/link.svg`} alt="" />

                  <p
                    style={{
                      fontSize: "15px",
                      margin: "auto",
                      color: "#616161",
                    }}
                  >
                    Link
                  </p>
                </span>

                <input
                  type="text"
                  onChange={handleChange}
                  name="sociallink"
                  defaultValue={OtherSoc.sociallink}
                  style={{
                    border: "none",
                    borderBottom: "2px solid #d4d4d4",
                    width: "85%",
                    margin: "auto",
                    marginLeft: "10px",
                    padding: "5px 10px",
                  }}
                />
              </div>

              <div className="d-flex justify-content-center">
                <button type="submit" className="btn btn-dark mt-4 col-lg-4">
                  Save
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
};

export default OtherSoc;
